module.exports = __webpack_public_path__ + "img/github.79962abc.svg";